import { getMarketBar } from 'api/v1/market'
import { store } from '../../store'
import { BarArrayToObject, getBarType } from './bar'

export class DataFeed {
  bars: any[] = []
  updateBars: any[] = []
  timer: any = null
  unSubscribeLine: {
    [x: string]: any
  } = {}
  constructor() {}
  onReady(cb: any) {
    setTimeout(() => {
      cb({
        exchanges: [],
        symbols_types: [],
        supports_time: false,
        supported_resolutions: [1, 5, 15, 30, 60, 240, '1D', '1W', '1M'],
        supports_marks: false,
        supports_timescale_marks: false,
      })
    }, 0)
  }
  resolveSymbol(
    symbolName: any,
    onSymbolResolvedCallback: any,
    onResolveErrorCallback: any,
  ) {
    // TODO: waiting for implement
    const currentSymbol = { quoteScale: 16 } as any //store.getState().orderbook.currentSymbol
    const quoteScale = currentSymbol
      ? 18 - Math.abs(currentSymbol?.quoteScale) ?? 18
      : 2
    const pricescale = Math.pow(10, quoteScale)
    const data = {
      name: symbolName,
      has_intraday: true,
      has_daily: true,
      has_weekly_and_monthly: true,
      session: '24x7',
      pricescale,
      minmov: 1,
    }

    setTimeout(function () {
      onSymbolResolvedCallback(data)
    }, 0)
  }
  getBars(
    symbolInfo: any,
    resolution: string,
    periodParams: any,
    onHistoryCallback: any,
    onErrorCallback: any,
  ) {
    this.bars = []
    const type = getBarType(resolution)
    const start = periodParams?.from * 1000
    const end = periodParams?.to * 1000
    if (periodParams.firstDataRequest) {
      getMarketBar(
        {
          symbol: symbolInfo.name,
          type: type,
        },
        {
          start,
          end,
        },
      ).then((r) => {
        if (r?.data?.results?.length) {
          const bars = BarArrayToObject(r.data.results).sort(
            (a, b) => a.time - b.time,
          )
          this.bars = bars || []
          onHistoryCallback(bars)
        } else {
          onHistoryCallback([], { noData: true })
        }
      })
    } else {
      getMarketBar(
        {
          symbol: symbolInfo.name,
          type: type,
        },
        {
          start,
          end,
        },
      ).then((r) => {
        if (r?.data?.results?.length) {
          const bars = BarArrayToObject(r.data.results).sort(
            (a, b) => a.time - b.time,
          )
          this.bars = bars || []
          onHistoryCallback(bars)
        } else {
          onHistoryCallback([], { noData: true })
        }
      })
    }
  }
  unSubscribeLastBar: any
  subscribeBars(
    symbolInfo: any,
    resolution: any,
    onRealtimeCallback: any,
    subscriberUID: any,
    onResetCacheNeededCallback: any,
  ) {
    this.bars?.length > 1 && onRealtimeCallback(this.bars[this.bars.length - 1])

    function handleChangeLastBar() {
      let currentValue: any
      currentValue = store.getState().market.lastBar
      const unFreezeCurrentValue = { ...currentValue }
      currentValue?.time && onRealtimeCallback(unFreezeCurrentValue)
    }
    !this.unSubscribeLastBar && (this.unSubscribeLastBar = {})
    this.unSubscribeLastBar[subscriberUID] =
      store.subscribe(handleChangeLastBar)
  }
  unsubscribeBars(subscriberUID: any) {
    this.unSubscribeLastBar[subscriberUID]()
  }
}
